import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="py-16 bg-[#eef3f7] text-center">
          <div className="max-w-2xl mx-auto px-6">
            <h2 className="text-2xl font-bold text-slate-700 mb-4">
              Oops! Something went wrong
            </h2>
            <p className="text-slate-600 mb-6">
              We encountered an error loading this section. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-slate-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-slate-500 transition-colors"
            >
              Refresh Page
            </button>
          </div>
        </section>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
